import FlexiblePayment from "@/assets/svg/task/flexible-payment.svg";
import { ArrowRight, Check, ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";
import Button from "../ui/button";

const messages = [
  "Pay directly from your YouTube Analytic",
  "Unlock rewards that may cover your Payroll expenses",
  "Withdraw your YouTube AdSense by the second",
  "Reinvest your income to compound more hires & ROI",
  "Enterprise-grade monetization security",
  "Multi-platform piracy revenue recovery",
];

export default function PayWithEnfiniPay() {
  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const visible = Array.from({ length: 3 }, (_, i) => {
    return messages[(startIndex + i) % messages.length];
  });

  return (
    <div className="lg:py-10 px-10 md:px-16 4xl:max-w-[100rem] 4xl:mx-auto relative overflow-hidden">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 xl:gap-20 items-start lg:items-center justify-center">
        <img
          src={FlexiblePayment}
          className="max-w-96 md:max-w-full lg:max-w-[450px] xl:max-w-[600px] my-auto order-2 lg:order-1"
          alt="Flexible Payement Options"
        />
        <div className="space-y-6 lg:w-1/2 order-1 lg:order-2">
          <h1 className="text-4xl md:text-5xl lg:text-4xl xl:text-5xl text-primaryLight">
            Pay with EnfiniPay
          </h1>
          <p className="text-white text-sm md:text-base">
            With EnfiniPay, payments turn into a growth engine—directly
            connected to your YouTube earnings for instant access, reinvestment,
            and rewards.
          </p>
          <p className="text-white text-sm md:text-base">
            Unlike traditional pay-now links, it’s built to pay smarter, protect
            your revenue, and unlock more value with every transaction.
          </p>
          <div className="flex items-stretch justify-between pt-4">
            <div className="overflow-hidden h-24">
              <div className="animate-scroll space-y-2 text-white">
                {[...messages, ...messages].map((msg, idx) => (
                  <div key={idx} className="flex gap-2 font-light">
                    <Check className="text-primary shrink-0" />
                    {msg}
                  </div>
                ))}
              </div>
            </div>
            {/* <div className="text-primary h-24 relative">
              <ChevronUp className="absolute right-0 top-0" />
              <ChevronDown className="absolute right-0 bottom-0" />
            </div> */}
          </div>
          <Button
            asChild
            className="group relative rounded-full shadow bg-primary text-white py-6 w-fit flex items-center justify-center gap-2 overflow-hidden hover:text-primary hover:bg-white !mt-10"
          >
            <a href="https://enfinipay.com" target="_blank">
              <span className="transform transition-transform duration-300 group-hover:translate-x-5">
                Connect with EnfiniPay
              </span>
              <ArrowRight className="transform transition-transform duration-300 group-hover:-translate-x-[158px]" />
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
